/**
 * Disk – SVG icon.
 */
import Screen from '@screen';

export default function DiskIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 90) * Screen.widthRatio}
      height={(height ? height : 84) * Screen.widthRatio}
      viewBox='0 0 90 84'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='30.1184'
        y='51.1184'
        width='32'
        height='5'
        rx='2'
        fill='url(#paint0_linear_settings_disk)'
      />
      <rect
        x='30.1184'
        y='60.1184'
        width='32'
        height='5'
        rx='2'
        fill='url(#paint1_linear_settings_disk)'
      />
      <rect
        x='30.1184'
        y='69.1184'
        width='32'
        height='5'
        rx='2'
        fill='url(#paint2_linear_settings_disk)'
      />
      <rect
        x='30.1184'
        y='78.1184'
        width='32'
        height='5'
        rx='2'
        fill='url(#paint3_linear_settings_disk)'
      />
      <path
        d='M86.2763 46.1647C86.2763 55.9062 80.2732 64.2623 71.7237 67.8169M54.5973 24.021C57.0742 23.1558 59.7398 22.685 62.5169 22.685C65.239 22.685 67.8539 23.1373 70.2896 23.9702M70.2896 23.9702C68.9674 12.2396 58.9003 3.11841 46.6774 3.11841C33.5554 3.11841 22.9179 13.6307 22.9179 26.5983C22.9179 29.4664 23.4383 32.2145 24.3909 34.7554M70.2896 23.9702C73.9881 25.2349 77.2724 27.3771 79.8869 30.1447M30.8377 37.3903C28.9193 36.1213 26.7377 35.2107 24.3909 34.7554C23.2738 34.5384 22.1193 34.4249 20.938 34.4249C11.0965 34.4249 3.11842 42.3091 3.11842 52.0348C3.11842 59.9198 8.36253 66.5945 15.5921 68.8385'
        stroke='url(#paint4_linear_settings_disk)'
        strokeWidth='6.23684'
        strokeLinecap='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_disk'
          x1='46.1184'
          y1='51.1184'
          x2='46.1184'
          y2='56.1184'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_settings_disk'
          x1='46.1184'
          y1='60.1184'
          x2='46.1184'
          y2='65.1184'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_settings_disk'
          x1='46.1184'
          y1='69.1184'
          x2='46.1184'
          y2='74.1184'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_settings_disk'
          x1='46.1184'
          y1='78.1184'
          x2='46.1184'
          y2='83.1184'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_settings_disk'
          x1='44.6974'
          y1='3.11841'
          x2='44.6974'
          y2='68.8385'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
